<template>
    <div>
        <el-row class="headerTop">
            <el-col :span="3">
                <div class="title">
                    {{this.$store.state.title}}
                </div>
            </el-col>
            <el-col :span="2">
                <div class="">
                    <el-button type="primary" @click="handleChangeDialog">增加企业</el-button>
                </div>
            </el-col>
        </el-row>


        <el-dialog title="填写企业信息" :visible.sync="modalVisible" width="50%" @close='handleClose' :before-close="handleBeforClose">
            <projectmessage msg-father="dad无可奉告" v-if="modalVisible"></projectmessage>
        </el-dialog>


        <el-row>
            <el-col :span='24'>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                >
                        <el-table-column
                            type="selection"
                            width="55"
                        >
                        </el-table-column>
                        <el-table-column
                            label="序号"
                            prop="serNum"
                            width="95"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="companyName"
                            label="企业名称"
                            width="205"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="stockShortName"
                            label="企业简称"
                            width="165"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="industry"
                            label="行业分类"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="图文介绍"
                            width=""
                        >
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="handleRouteAdve(scope.$index,scope)"
                                type="text"
                                size="small">
                                编辑
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="母企业信息"
                            width=""
                        >
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="handleMotherUpload(scope.$index,scope)"
                                type="text"
                                size="small">
                                上传
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="子企业信息"
                            width=""
                        >
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="handleChildUpload(scope.$index,scope)"
                                type="text"
                                size="small">
                                上传
                                </el-button>
                                <!-- <el-button
                                v-if="scope.row.zip"
                                @click.native.prevent="deleteRow(scope.$index,scope)"
                                type="text"
                                size="small">
                                更新
                                </el-button> -->
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width=""
                        >
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="deleteRow(scope.$index,scope)"
                                type="text"
                                size="small">
                                删除
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            prop="modifyTime"
                            label="最近更新时间"
                        >
                        </el-table-column>
                </el-table>
            </el-col>
            <el-col>
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pagesize"
                        layout="prev, pager, next, jumper"
                        v-show="showPagination"
                        :total=total>
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <el-dialog title="编辑介绍信息" :visible.sync="imgVisible" v-if="imgVisible" width="50%" @close='handleClose' :before-close="handleBeforClose">
            <el-row>
                <el-col>
                    <div class="imgbox">
                        <el-upload
                            class="avatar-uploader"
                            v-model="upImg"
                            action="https:///oaapi.dianpiaobao.com/upload/junGongMgsProfileUpload"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                        >
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>


        <el-dialog title="填写企业信息" :visible.sync="motherVisible" v-if="motherVisible" width="50%" @close='handleClose' :before-close="handleBeforClose">
            <el-row>
                <el-col>
                    <div  class="uploadBox" v-for="(it,index) in uploadList" :key="index">
                        <div class="uploadItem">
                            <p class='uploadP'>{{it.name}}</p>
                            <el-upload
                                class="upload-demo"
                                drag
                                style="width:200px"
                                :limit=1
                                :ref="it.type"
                                :headers="myheader"
                                :data="it.type"
                                :before-upload='handleBefore'
                                :action="it.id"
                                :http-request="billSettlement"
                                >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                            </el-upload>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="填写子企业信息" :visible.sync="childVisible" v-if="childVisible" width="50%" @close='handleClose' :before-close="handleBeforClose">
            <el-row>
                <el-col>
                    <div class="timeBox">
                            <el-date-picker
                                @change='choseeDate'
                                v-model="value"
                                type="year"
                                value-format="yyyy"
                                placeholder="选择年">
                            </el-date-picker>
                    </div>
                    <div  class="uploadBox" v-for="(it,index) in childUploadList" :key="index">
                        <div class="uploadItem">
                            <p class='uploadP'>{{it.name}}</p>
                            <el-upload
                                class="upload-demo"
                                drag
                                :limit=1
                                ref="upload"
                                :headers="myheader"
                                :before-upload='handleChildBefore'
                                :data="it.type"
                                :action="it.id"
                                :http-request="CmpSubsidiaryo"
                                >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                            </el-upload>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>


    </div>
</template>
<script>
import projectmessage from './projectmessage'
export default {
    components:{
        projectmessage
    },
    computed: {
        myheader(){
            return {
                "Content-Type":"multipart/form-data"
            }
        }
    },
    data(){
        return{
            upImg:'',
            imageUrl:'',
            imgtitle:'',
            value:'',
            imgVisible:false,
            modalVisible:false,
            motherVisible:false,
            childVisible:false,
            uploadList:[{name:'票据结算',id:'/shangPiao/importCmpYsyfpj',type:'zx'},{name:'财务概况',id:'/shangPiao/importCmpTbCwgk',type:'zc'},
                        {name:'费用情况',id:'/shangPiao/importCmpTbFyqk',type:'zv'},{name:'债券融资',id:'/shangPiao/importCmpTbZqrz',type:'zb'}
                        ],
            childUploadList:[
                {name:'1001、子企业情况',id:'/shangPiao/importCmpSubsidiary',type:'zqy'},{name:'1002、表决权不足半数但能控制的子企业',id:'/shangPiao/importCmpSubsidiary',type:'bjqbz'},
                {name:'1003、重要非全资子公司',id:'/shangPiao/importCmpSubsidiaryFinance',type:'1'},{name:'1004、本期新纳入合并范围的主体',id:'/shangPiao/importCmpSubsidiary',type:'bqxnr'},
                {name:'1005、非同一控制下的合并企业',id:'/shangPiao/importCmpSubsidiary',type:'ftykzxdhbqy'},{name:'1006、本期不再纳入合并范围的子公司',id:'/shangPiao/importCmpSubsidiaryBqbznrhbfw',type:'ad'},
                {name:'1007、有半数以上表决权但未能控制的子企业',id:'/shangPiao/importCmpSubsidiaryBsysbjq',type:'af'},
                {name:'1009、应收账款情况',id:'/shangPiao/importCmpYsk',type:'aq'},{name:'1010、预付账款情况',id:'/shangPiao/importCmpYfzk',type:'aw'},
                {name:'1011、应收股利情况',id:'/shangPiao/importCmpYsgl',type:'ae'},{name:'1012、其他应收款情况',id:'/shangPiao/importCmpYskOther',type:'ar'},
                {name:'1013、长期股权投资明细',id:'/shangPiao/importCmpGqtz',type:'at'},
                {name:'1015、重要联营与合同公司财务报表',id:'/shangPiao/importCmpSubsidiaryFinance',type:'2'},{name:'1016、在建工程情况',id:'/shangPiao/importCmpDevelop',type:'1016'},
                {name:'1017、开发支出情况',id:'/shangPiao/importCmpDevelop',type:'1017'},{name:'1018、商誉与减值损失情况',id:'/shangPiao/importCmpGoodwill',type:'ay'},
                {name:'1019、应收&预付账款情况',id:'/shangPiao/importCmpYfAndYsk',type:'au'},{name:'1020、对内对外担保情况',id:'/shangPiao/importCmpGuarantee',type:'ai'},
                {name:'1021、关联方交易情况',id:'/shangPiao/importCmpRelevance',type:'ao'},{name:'1022、僵尸企业名单',id:'/shangPiao/importCmpJiangShi',type:'ap'}
            ],
            tableData: [{
            modifyTime: '2016-05-02',
            serNum: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: true
            }, {
            modifyTime: '2016-05-04',
            serNum: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1517 弄',
            zip: true
            }, {
            modifyTime: '2016-05-01',
            serNum: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1519 弄',
            zip: false
            }, {
            modifyTime: '2016-05-03',
            serNum: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1516 弄',
            zip: false
            }],
            showPagination:true,
            total:0,
            pagesize:10,
            currentPage:1,
            motherVal:'',
            childVal:'',
            nameVal:''
        }
    },
    mounted(){
        this.handleajax(this.currentPage);
    },
    methods:{
        handleajax(val){
            this.ajax.post('/shangPiao/getCmpListPage',{bizContent: {currentPage: val,pageSize:this.pagesize,industry:'军工企业'}})
                .then(
                    result=>{
                    if(result.data.status=='0000'){
                        this.tableData=result.data.data.data;
                        this.total=result.data.data.total;
                    }else{
                        this.$message.error(result.message);
                    }
                    }
                )
        },
        deleteRow(index,val){
            this.ajax.post('/shangPiao/cmpDel',{bizContent: {id:val.row.id}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.currentPage=1
                            this.handleajax(this.currentPage)
                        }
                    }
                )
        },
        handleRouteAdve(index,val){
            this.nameVal = val.row.companyName;
            this.imgVisible = !this.imgVisible
        },
        handleAvatarSuccess(res, item) {
            const fileObj = item.raw
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('cmpName', this.nameVal)
            this.ajax.post('/upload/junGongMgsProfileUpload',form)
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.imageUrl = URL.createObjectURL(item.raw);
                            this.$message('上传成功！');
                        }else{
                            this.$message.error('上传失败！');
                        }
                    }
            )
        },
        handleMotherUpload(index,val){
            this.motherVal = val.row.companyName
            this.motherVisible=!this.motherVisible
        },
        handleChildUpload(index,val){
            this.childVal = val.row.companyName
            this.childVisible=!this.childVisible
        },
        handleChangeDialog(){
            this.modalVisible=!this.modalVisible;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleClose(){
            this.value =''
            this.currentPage=1
            this.handleajax(this.currentPage)
        },
        handleCurrentChange(val) {
            this.handleajax(val);
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleBefore(file){
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 10;
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if(!isLt2M){
                this.$message.error('上传模板大小不能超过 10MB');
                return false;
            }
        },
        handleChildBefore(file){
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 10;
            if(this.value == ''){
                this.$message.error('请先选择年份');
                return false;
            }
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if(!isLt2M){
                this.$message.error('上传模板大小不能超过 10MB');
                return false;
            }
        },

        ///////////////////////////////////母企业导入
        billSettlement (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('mgsmc', this.motherVal)
            let formTwo = JSON.stringify(form)
            let url = item.action
            this.ajax.post(url,form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs[item.data].clearFiles()
                                this.$message(result.message);
                            }
                        }
            )
        },

        /////////////////////////////////子企业导入
        CmpSubsidiaryo (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            form.append('file', fileObj)
            form.append('mgsmc', this.childVal)
            form.append('date', this.value)
            let type = item.data
            form.append('importtype', type)
            // 文件对象
            let formTwo = JSON.stringify(form)
            let url = item.action
                this.ajax.post(url,form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs[item.data].clearFiles()
                                this.$message(result.message);
                            }
                        }
            )
        },
        choseeDate(val){
            this.value=val;
            const mainImg = this.$refs.upload;
            mainImg.forEach(item => {
                // item.uploadFiles.length = 0;
                item.clearFiles();
            });
        },
        handleBeforClose(done){
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        }
    }
}
</script>
<style scoped>
.el-upload-dragger{
    width: 200px!important;
}
.headerTop{
    margin-top: 10px;
    margin-bottom: 10px;
}
.title{
    color: #333333FF;
    font-size: 24px;
}
.block{
    margin-top: 20px;
    width: 100%;
    text-align: center;
}
.timeBox{
    height: 60px;;
    margin-left: 3%;
    margin-top: 15px;
}
.uploadBox{
    width: 100%;
}
.uploadItem{
    float: left;
    height: 300px;;
    width: 30%;
    margin-left: 3%;
    margin-bottom: 15px;
}
.uploadP{
    color: #343C4EFF;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    margin: 5px 0;
    height: 30px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.imgbox{
    width: 100%;
    height: 180px;
    line-height: 100px;
    text-align: center;
    padding-top: 20px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
    border: 1px solid #eee;
    margin: 20px 0;
}
.avatar {
    width: 138px;
    height: 138px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/page/bussinessticket/projectMol.vue